const Text = {
  variants: {
    highlight: {
      bg: "#f9f8f6",
      px: 2,
      py: 0.5,
      fontWeight: 700,
    },
    secondary: {
      textTransform: "none",
      fontWeight: 400,
      color: "bluefrance",
    },
    slight: {
      color: "#666666",
      fontSize: "0.8rem",
      fontStyle: "italic",
    },
    card: {
      p: 8,
      bg: "#F9F8F6",
      display: "block",
    },
  },
};

export { Text };
